import React, { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBreakdownTabContext } from '../../contexts/BreakdownTabContext';

/** 将历史路径 `#/breakdown` 重定向到 `#/breakdown/:breakdownID`（来自上下文 / localStorage）。 */
const BreakdownPathRedirect: React.FC = () => {
  const { breakdownId } = useBreakdownTabContext();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (breakdownId) {
      navigate(`/breakdown/${breakdownId}`, { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  }, [breakdownId, navigate]);

  return null;
};

export default BreakdownPathRedirect;
